import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Box, useMediaQuery, useTheme } from '@mui/material';

export default function CustomDialog({ isOpen, handleClose, title, action, maxWidth, children, width, padding, paid }) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    return (
        <Dialog
            onClose={(e, reason) => {
                if (reason === 'backdropClick') return;
                handleClose();
            }}
            aria-labelledby="customized-dialog-title"
            open={isOpen}
            PaperProps={{
                sx: { 
                    width: isMobile ? '95%' : width, 
                    padding: isMobile ? "8px" : (padding || "5px 5px"),
                    margin: isMobile ? '16px' : '32px',
                    maxHeight: isMobile ? 'calc(100% - 32px)' : 'calc(100% - 64px)',
                },
            }}
            maxWidth={maxWidth}
            fullWidth
            disableEscapeKeyDown
        >
            <DialogTitle 
                fontSize={isMobile ? '15px' : '17px'} 
                sx={{ 
                    m: 0, 
                    p: isMobile ? 1 : 0.5, 
                    color: theme?.palette?.primary?.main, 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "space-between" 
                }} 
                id="customized-dialog-title"
            >
                {title}
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    size={isMobile ? "small" : "medium"}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ padding: isMobile ? "8px" : "10px 10px", border: 'none' }}>
                {children}
            </DialogContent>
            <DialogActions sx={{ padding: isMobile ? '8px' : 0, width: '100%', flexWrap: 'wrap', gap: 1 }}>
                {action}
            </DialogActions>
        </Dialog>
    );
}
